import { format, parse } from 'date-fns';
/**
 * Generic getter of Date object from string, by specifying the format as reported at:
 * https://date-fns.org/v2.28.0/docs/parse
 *
 * Used mostly to handle the exception and undefined string as a undefined date.
 *
 * @param {(string | undefined | null)} date
 * @param {string} format
 * @return {*}  {(Date | undefined)}
 */
export const getDateFromGenericString = (
    date: string | undefined | null,
    dateFormat: string // specify the format as eg. "yyyymmdd"
): Date | undefined => {
    if (!date) return undefined;

    try {
        return parse(date, dateFormat, new Date());
    } catch (error) {
        console.log('[MYL] Error format date', error);
        return undefined;
    }
};

/**
 * Generic getter of string from Date object, by specifying the format as reported at:
 * https://date-fns.org/v2.28.0/docs/parse
 *
 * Used mostly to handle the exception and undefined Date as an empty string.
 *
 * @param {(string | undefined | null)} date
 * @param {string} format
 * @return {*}  {(Date | undefined)}
 */
export const getStringFromDate = (
    date: Date | undefined | null,
    dateFormat: string // specify the format as eg. "yyyymmdd"
): string => {
    if (!date) return '';

    try {
        return format(date, dateFormat);
    } catch (error) {
        console.log(`[MYL] Error formatting date ${date}:`, error);
        return '';
    }
};

export const fromStringToDate = (
    date: string //dd/MM/yyyyy
): Date => {
    try {
        const day = parseInt(date?.slice(0, 2));
        const month = parseInt(date?.slice(3, 5)) - 1;
        const year = parseInt(date?.slice(6, 10));

        return new Date(year, month, day);
    } catch (error) {
        console.log('[MYL] Error format date', error);
    }
};
